import { createSignal, onCleanup, onMount } from 'solid-js';

export function useIsScreenWide(breakpoint = 767, debounceTime = 100) {
  const [isWide, setIsWide] = createSignal(typeof window !== 'undefined' && window.innerWidth > breakpoint);

  let timer: NodeJS.Timeout;

  function handleResize() {
    clearTimeout(timer);
    timer = setTimeout(() => {
      setIsWide(window.innerWidth < breakpoint);
    }, debounceTime);
  }

  onMount(() => {
    handleResize();
    window.addEventListener('resize', handleResize);
  });

  onCleanup(() => {
    window.removeEventListener('resize', handleResize);
    clearTimeout(timer);
  });

  return isWide;
}
